module.exports = __webpack_public_path__ + "static/media/closer.fadace38.svg";